import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { palette } from "../../../../assets/styles/Palette";
import { useNavigate } from "react-router-dom";
import {
  Body1,
  Body2,
  Body3,
  Caption1,
} from "../../../../assets/styles/Typography";
import { useAtom } from "jotai";
import {
  MEMBER_TYPE,
  CUSTOMER_ID,
  CUSTOMER_NAME,
  CUSTOMER_DETAIL,
  SELECTED_CUSTOMER_TYPE,
  CUSTOMER_LIST,
} from "../../../AtomStates";
import { Button } from "../../../../assets/styles/ButtonStyle";
import {
  getCustomerDetailOnServer,
  updateCustomerOnServer,
  createDisplayOnServer,
  updateDisplayOnServer,
} from "../../../../utils/indexedDB";
import { IS_LOGGED_IN } from "../../../AtomStates";
import PopupWrap from "../../../../assets/styles/Popup";

const OrganismCustomerItem = ({
  isNoData,
  onAdd,
  setShowCustomerPopup,
  setCompanyName,
  setAddress,
  setCompanyInfo,
  setBoardType,
  setInitialCustomer,
  setIsEdit,
  customer,
  selectedCustomerId,
  boardType,
  getOrganizationUserList,
}) => {
  const navigate = useNavigate();
  const [memberType] = useAtom(MEMBER_TYPE);
  const [customerDetail, setCustomerDetail] = useAtom(CUSTOMER_DETAIL);
  const [customerId, setCustomerId] = useAtom(CUSTOMER_ID);
  const [customerName, setCustomerName] = useAtom(CUSTOMER_NAME);
  const [isLoggedIn] = useAtom(IS_LOGGED_IN);
  const [selectedCustomerType, setSelectedCustomerType] = useAtom(
    SELECTED_CUSTOMER_TYPE
  );
  const [menuOpen, setMenuOpen] = useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const menuRef = useRef();
  const [, setCustomerList] = useAtom(CUSTOMER_LIST);

  const handleClick = () => {
    if (isNoData && onAdd) {
      onAdd();
    }
    setCustomerId(customer._id);
    setCustomerName(customer.companyName);
  };

  const handleDeleteCustomer = async (customerId) => {
    await updateCustomerOnServer(customerId, { deleteState: 1 });
    setCustomerList((prev) => prev.filter((c) => c._id !== customerId));
  };

  // 바깥 클릭 시 메뉴 닫기
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
 
  const getDefaultDisplayData = () => {
    return [
      {
        deviceTitle: "대형 세로형 사이니지",
        deviceSpec: {
          deviceWidth: "1080",
          deviceHeight: "1920",
          deviceWidthMM: "685",
          deviceHeightMM: "1218",
          deviceCm: "139.70cm", // 55인치 → cm
          deviceResolution: "FHD",
          deviceDPI: "(세로)FHD | 1080 × 1920",
          deviceInch: "55인치",
        },
      },
      {
        deviceTitle: "중형 세로형 사이니지",
        deviceSpec: {
          deviceWidth: "1080",
          deviceHeight: "1920",
          deviceWidthMM: "535",
          deviceHeightMM: "952",
          deviceCm: "109.22cm", // 43인치 → cm
          deviceResolution: "FHD",
          deviceDPI: "(세로)FHD | 1080 × 1920",
          deviceInch: "43인치",
        },
      },
      {
        deviceTitle: "소형 세로형 키오스크",
        deviceSpec: {
          deviceWidth: "1080",
          deviceHeight: "1920",
          deviceWidthMM: "336",
          deviceHeightMM: "598",
          deviceCm: "68.58cm", // 27인치 → cm
          deviceResolution: "FHD",
          deviceDPI: "(세로)FHD | 1080 × 1920",
          deviceInch: "27인치",
        },
      },
    ];
  };

  // 기본 디스플레이 데이터를 서버에 저장
  const saveDefaultDisplays = async (customerId) => {
    const defaultDisplays = getDefaultDisplayData();
    console.log("defaultDisplays", defaultDisplays);

    try {
      for (const displayData of defaultDisplays) {
        console.log("displayData", displayData);
        // 1. 먼저 새 디스플레이 ID를 생성
        const newDisplayId = await createDisplayOnServer(isLoggedIn);

        if (!newDisplayId) {
          console.error("디스플레이 ID 생성에 실패했습니다.");
          continue;
        }

        displayData.customer = customerId;

        // 2. 생성된 ID에 디스플레이 정보를 업데이트
        await updateDisplayOnServer(newDisplayId, displayData);
      }
    } catch (error) {
      console.error("기본 디스플레이 저장 실패:", error);
    }
  };

  return (
    // <DeviceCard NoData={isNoData} onClick={handleClick}>
    <DeviceCard NoData={isNoData}>
      {!isNoData ? (
        <>
          <div style={{ position: "relative" }}>
            <div className="device-info">
              {/* <DeviceIcon status={customer?.status}>📺</DeviceIcon> */}
              <div className="info">
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <Body1 color="gray800" align="left">
                    {customer?.companyName || " "}
                  </Body1>
                  <span
                    style={{
                      position: "absolute",
                      // top: 16,
                      right: 1,
                      cursor: "pointer",
                      zIndex: 2,
                    }}
                    onClick={() => setMenuOpen((open) => !open)}
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <circle cx="5" cy="12" r="2" fill="#888" />
                      <circle cx="12" cy="12" r="2" fill="#888" />
                      <circle cx="19" cy="12" r="2" fill="#888" />
                    </svg>
                  </span>
                </div>
                {memberType !== 32 && (
                  <Body3 color="gray600" align="left">
                    {customer?.address || " "}
                  </Body3>
                )}
                {/* <StatusBadge status={device?.status || "온라인"}>
                  <Caption1 color={device?.status === "온라인" ? "white" : "gray600"}>
                    {device?.status || "온라인"}
                  </Caption1>
                </StatusBadge> */}
              </div>
            </div>
            <div className="device-details">
              <DetailItem>
                <Body3 color="gray500">등록 콘텐츠 수</Body3>
                <Body3 color="gray700">{customer?.viewTotalCount || "-"}</Body3>
              </DetailItem>
              <DetailItem>
                <Body3 color="gray500">
                  {memberType === 32 || Number(selectedCustomerType) === 3 ? "디스플레이 정보" : "등록 디스플레이 수"}
                </Body3>
                <Body3 color="gray700">
                  {memberType === 32 || Number(selectedCustomerType) === 3 
                    ? `${customer?.displaySize || ""}UHD 3840×2160 ${customer?.displayRatio || ""}`
                    : (customer?.deviceCount || "-")
                  }
                </Body3>
              </DetailItem>
              <DetailItem>
                <Body3 color="gray500">등록일</Body3>
                <Body3 color="gray700">
                  {(() => {
                    if (!customer?.createDate) return "2025-01-01";
                    
                    const dateStr = String(customer.createDate);
                    console.log('Original createDate:', dateStr); // 디버깅용
                    
                    try {
                      // Date 객체로 변환 시도
                      const date = new Date(dateStr);
                      
                      // 유효한 날짜인지 확인
                      if (!isNaN(date.getTime())) {
                        const year = date.getFullYear();
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const day = String(date.getDate()).padStart(2, '0');
                        return `${year}-${month}-${day}`;
                      }
                    } catch (e) {
                      console.log('Date parsing error:', e);
                    }
                    
                    // Date 변환 실패 시 문자열 처리
                    if (dateStr.includes('-')) {
                      // "YYYY-MM-DD HH:MM:SS" 또는 "YYYY-MM-DD" 형식
                      const datePart = dateStr.split(' ')[0];
                      const parts = datePart.split('-');
                      if (parts.length >= 3) {
                        return `${parts[0]}-${parts[1]}-${parts[2]}`;
                      }
                    }
                    
                    if (dateStr.includes('.')) {
                      // "YYYY.MM.DD" 형식
                      const parts = dateStr.split('.');
                      if (parts.length >= 3) {
                        return `${parts[0]}-${parts[1].padStart(2, '0')}-${parts[2].padStart(2, '0')}`;
                      }
                    }
                    
                    if (dateStr.includes('/')) {
                      // "YYYY/MM/DD" 형식
                      const parts = dateStr.split('/');
                      if (parts.length >= 3) {
                        return `${parts[0]}-${parts[1].padStart(2, '0')}-${parts[2].padStart(2, '0')}`;
                      }
                    }
                    
                    // 모든 변환 실패 시 기본값
                    return "2025-01-01";
                  })()}
                </Body3>
              </DetailItem>
            </div>
            <Button
              BlueOutline
              style={{
                marginTop: 20,
                width: "100%",
                background: "#fff",
                padding: "8px 16px",
              }}
              onClick={async (e) => {
                e.stopPropagation();

                if (memberType && String(memberType).startsWith("9")) {
                  if (
                    Number(selectedCustomerType) === 1 ||
                    Number(selectedCustomerType) === 2 ||
                    Number(selectedCustomerType) === 3 ||
                    Number(selectedCustomerType) === 4 ||
                    Number(selectedCustomerType) === 5
                  ) {
                    setCustomerId(customer._id);
                    sessionStorage.setItem("customerId", customer._id);
                    setCustomerName(customer.companyName);
                    setCustomerDetail(customer);
                    if (customer?.deviceCount === 0) {
                      await saveDefaultDisplays(customer._id);
                    }

                    navigate(
                      Number(selectedCustomerType) === 1
                        ? "/DashBoard"
                        : Number(selectedCustomerType) === 2
                        ? "/ApiDashBoard"
                        : Number(selectedCustomerType) === 3
                        ? "/EducationDashBoard"
                        : Number(selectedCustomerType) === 4
                        ? "/InfoDashBoard"
                        : Number(selectedCustomerType) === 5
                        ? "/EduInfoDashBoard"
                        : "/DashBoard"
                    );
                  }
                } else if (String(memberType).startsWith("1")) {
                  setCustomerId(customer._id);
                  sessionStorage.setItem("customerId", customer._id);
                  setCustomerName(customer.companyName);
                  setCustomerDetail(customer);
                  if (customer?.deviceCount === 0) {
                    await saveDefaultDisplays(customer._id);
                  }
                  navigate("/DashBoard");
                } else if (String(memberType).startsWith("2")) {
                  setCustomerId(customer._id);
                  sessionStorage.setItem("customerId", customer._id);
                  setCustomerName(customer.companyName);
                  setCustomerDetail(customer);
                  navigate("/ApiDashBoard");
                } else if (String(memberType).startsWith("3")) {
                  setCustomerId(customer._id);
                  sessionStorage.setItem("customerId", customer._id);
                  setCustomerName(customer.companyName);
                  setCustomerDetail(customer);
                  if (customer?.deviceCount === 0) {
                    await saveDefaultDisplays(customer._id);
                  }
                  navigate("/EducationDashBoard");
                } else if (String(memberType).startsWith("4")) {
                  setCustomerId(customer._id);
                  sessionStorage.setItem("customerId", customer._id);
                  setCustomerName(customer.companyName);
                  setCustomerDetail(customer);
                    navigate("/InfoDashBoard");
                }
                else if (String(memberType).startsWith("5")) {
                  setCustomerId(customer._id);
                  sessionStorage.setItem("customerId", customer._id);
                  setCustomerName(customer.companyName);
                  setCustomerDetail(customer);
                    navigate("/InfoDashBoard");
                }
                else {
                  setCustomerId(customer._id);
                  sessionStorage.setItem("customerId", customer._id);
                  setCustomerName(customer.companyName);
                  setCustomerDetail(customer);
                  if (customer?.deviceCount === 0) {
                    await saveDefaultDisplays(customer._id);
                  }
                  navigate("/DashBoard");
                }
              }}
            >
              <Body2 color="primary">관리 페이지 이동</Body2>
            </Button>

            {/* 토글 메뉴 */}
            {menuOpen && (
              <div
                ref={menuRef}
                style={{
                  position: "absolute",
                  top: 15,
                  right: -100,
                  background: "#fff",
                  border: "1px solid #eee",
                  borderRadius: 8,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  padding: "12px 0",
                  minWidth: 120,
                  zIndex: 10,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    textAlign: "left",
                    color: palette.gray700,
                    padding: "10px 10px",
                    cursor: "pointer",
                    fontSize: 15,
                    gap: 8,
                  }}
                  onClick={() => {
                    setCompanyName(customer.companyName || "");
                    setAddress(customer.address || "");
                    setCompanyInfo(customer.companyInfo || "");
                    if (setBoardType)
                      setBoardType(customer.boardType || "general");
                    setInitialCustomer({
                      companyName: customer.companyName || "",
                      address: customer.address || "",
                      companyInfo: customer.companyInfo || "",
                      boardType: customer.boardType || "general",
                    });
                    setIsEdit(true);
                    if (selectedCustomerId) selectedCustomerId(customer._id);
                    setShowCustomerPopup(true);
                  }}
                >
                  <svg width="20" height="20" fill="none">
                    <rect
                      x="3"
                      y="4"
                      width="14"
                      height="12"
                      rx="2"
                      stroke="#888"
                      strokeWidth="1.5"
                    />
                    <path d="M3 8h14" stroke="#888" strokeWidth="1.5" />
                  </svg>
                  {memberType === 32 || Number(selectedCustomerType) === 3 ? "교내 게시판 정보" : "고객사 정보"}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    textAlign: "left",
                    padding: "4px 10px",
                    cursor: "pointer",
                    gap: 8,
                    color: palette.gray700,
                    fontSize: 15,
                  }}
                  onClick={() => {
                    setShowConfirmPopup(true);
                  }}
                >
                  <TrashIcon />
                  삭제
                </div>
              </div>
            )}
          </div>
        </>
      ) : (
        <div className="noData" onClick={() => {
          // prop으로 입력받은 boardType 설정
          if (boardType && setBoardType) {
            setBoardType(boardType);
          }
          
          // memberType이 32이고 getOrganizationUserList 함수가 있으면 호출
          if (memberType === 32 && getOrganizationUserList) {
            getOrganizationUserList();
          } else {
            console.log("getOrganizationUserList", getOrganizationUserList);
            setShowCustomerPopup(true);
          }
        }}
        style={{ cursor: "pointer" }}
        >
          <AddIcon>+</AddIcon>
          <Body2 color="primary">
            {memberType === 32 || Number(selectedCustomerType) === 3 ? "교내 게시판 등록하기" : "고객사 등록하기"}
          </Body2>
        </div>
      )}

      {showConfirmPopup && (
        <PopupWrap
          Warning
          title="정말 삭제 하시겠습니까?"
          message={
            <>
              {memberType === 32 || Number(selectedCustomerType) === 3
                ? "해당 교내 게시판의 모든 데이터가 삭제됩니다."
                : "해당 고객사의 모든 데이터가 삭제됩니다."}
            </>
          }
          buttonType="Outline"
          closeText="취소"
          confirmText="삭제"
          isModal={false}
          onCancel={() => {
            setShowConfirmPopup(false);
          }}
          onConfirm={() => {
            setShowConfirmPopup(false);
            handleDeleteCustomer(customer._id);
          }}
        />
      )}
    </DeviceCard>
  );
};

export default OrganismCustomerItem;

const DeviceCard = styled.div`
  max-width: 31.9%;
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  padding: 20px 20px 16px 20px;
  border-radius: 12px;
  transition: all 0.2s ease-in-out;
  
  // NoData(신규 등록) 카드만 다른 스타일
  background: ${props => props.NoData ? '#fff' : 'rgba(37, 110, 244, 0.05)'};
  border: ${props => props.NoData ? `1px solid ${palette.outlineGray}` : 'none'};

  // &:hover {
  //   border-color: ${palette.primary};
  //   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  //   transform: translateY(-2px);
  // }

  .device-info {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 16px;

    .info {
      display: flex;
      flex-direction: column;
      gap: 4px;
      flex: 1;
    }
  }

  .device-details {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-top: 16px;
    // border-top: 1px solid ${palette.outlineGray};
  }

  .noData {
    width: 100%;
    height: 100%;
    min-height: 200px;
    padding: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    background: ${palette.white};
  }
`;

const DeviceIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: ${(props) =>
    props.status === "온라인"
      ? "#E8F5E8"
      : props.status === "오프라인"
      ? "#FFE8E8"
      : "#F5F5F5"};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;
`;

const StatusBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 12px;
  background: ${(props) =>
    props.status === "온라인"
      ? "#22C55E"
      : props.status === "오프라인"
      ? "#EF4444"
      : "#94A3B8"};
  width: fit-content;
  margin-top: 4px;
`;

const DetailItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${palette.outlineGray};

  &:last-child {
    border-bottom: none;
  }
`;

const AddIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: #f7f8fa;
  color: ${palette.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 500;
`;

// const CustomerCard = ({
//   companyName,
//   description,
//   displayCount,
//   contentCount,
//   registerDate,
//   onManageClick,
// }) => {
//   return (
//     <Card>
//       <Top>
//         <LogoCircle />
//         <div>
//           <Body1 color="gray800" style={{ fontWeight: 700, marginBottom: 4 }}>
//             {companyName}
//           </Body1>
//           <Body3 color="gray600">{description}</Body3>
//         </div>
//       </Top>
//       <InfoTable>
//         <InfoRow>
//           <Body3 color="gray500">등록 디스플레이 수</Body3>
//           <Body3 color="gray700">{displayCount} 대</Body3>
//         </InfoRow>
//         <InfoRow>
//           <Body3 color="gray500">등록 콘텐츠 수</Body3>
//           <Body3 color="gray700">{contentCount} 건</Body3>
//         </InfoRow>
//         <InfoRow>
//           <Body3 color="gray500">등록일</Body3>
//           <Body3 color="gray700">{registerDate}</Body3>
//         </InfoRow>
//       </InfoTable>
//       <Button
//         style={{ marginTop: 24, width: "100%" }}
//         Outline
//         onClick={onManageClick}
//       >
//         <Body2 color="primary">관리 페이지 이동</Body2>
//       </Button>
//     </Card>
//   );
// };

// const Card = styled.div`
//   width: 320px;
//   background: ${palette.bgGray};
//   border-radius: 16px;
//   padding: 28px 24px 24px 24px;
//   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
// `;

// const Top = styled.div`
//   display: flex;
//   align-items: flex-start;
//   gap: 16px;
//   margin-bottom: 20px;
// `;

// const LogoCircle = styled.div`
//   width: 40px;
//   height: 40px;
//   border-radius: 50%;
//   background: ${palette.gray200};
//   margin-right: 8px;
// `;

// const InfoTable = styled.div`
//   width: 100%;
//   margin-top: 8px;
// `;

// const InfoRow = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   margin-bottom: 8px;
//   &:last-child {
//     margin-bottom: 0;
//   }
// `;

const TrashIcon = () => (
  <div
    style={{
      width: "20px",
      height: "20px",
      position: "relative",
      opacity: 1,
    }}
  >
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6H5H21"
        stroke="#888"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
        stroke="#888"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11V17"
        stroke="#888"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 11V17"
        stroke="#888"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
